import {
  CheckType,
  ContainerType,
  InventoryStatusCode,
  InventoryType,
  PackingTypes,
  SortOrder,
} from "~/utils/constants";
import { PaginationParams } from "../type";
import { TServiceTicket } from "~/types";

export enum SortByField {
  INVENTORY_REF = "inventoryRef",
  ARTIST_NAME = "artistName",
  TITLE = "title",
  CREATED_AT = "createdAt",
  PROJECT_NAME = "projectName",
  SUB_CLIENT_NAME = "subClientName",
  STATUS = "status",
}

export type QueryInventory = {
  itemType?: InventoryType;
  status?: InventoryStatusCode;
  parentInventoryId?: string;
  checkParentId?: CheckType;
  clientId?: string;
  subClientId?: string;
  sortBy?: SortByField;
  sortOrder?: SortOrder;
  projectId?: string;
  serviceTicketId?: string;
};

export interface CreateInventoryParams {
  title: string;
  medium: string;
  clientId: string;
  storageId: string;
  description?: string;
  pieceCount: string;
  packageCount: string;
  length: number;
  width: number;
  height: number;
  weight: number;
  clientInternalRef: string;
  artistName: string;
  packingType: PackingTypes;
  parts: number;
  value: number;
  status: InventoryStatusCode;
  type?: InventoryType;
  location?: string;
  consignee?: string;
  notes?: string;
  specialHandling: string[];
  serviceTicketId: string;
  parentInventoryId: string;
  duplicates: number;
  size: number;
  itemType?: InventoryType;
  containerType?: ContainerType;
  locationId: string;
  isPacked: boolean;
  imageIds: string[];
  pieceIds: string[];
}

export interface ExtendedCreateInventoryParams extends CreateInventoryParams {
  containerId?: string;
  monthlyCost?: number;
  inventoryRef?: string;
}

export type UpdateInventoryParams = {
  id: string;
  files?: File[];
  imageIdsToDelete?: string[];
  title?: string;
  size?: number;
  medium?: string;
  specialHandling?: string[];
  clientId?: string;
  storageId?: string;
  parentInventoryId?: string;
  description?: string;
  pieceCount?: string;
  packageCount?: string;
  length?: number;
  width?: number;
  height?: number;
  weight?: number;
  clientInternalRef?: string;
  artistName?: string;
  packingType?: PackingTypes;
  parts?: number;
  value?: number;
  status?: InventoryStatusCode;
  itemType?: InventoryType;
  containerType?: ContainerType;
  locationId?: string | null;
  serviceTicketId?: string;
  consignee?: string;
  notes?: string;
  pieceIds?: string[];
  pieceIdsToRemove?: string[];
};

export interface GetInventoriesParams extends PaginationParams {
  clientId?: string;
  status?: InventoryStatusCode;
  locationId?: string;
  itemType?: InventoryType;
  parentInventoryId?: string;
  checkParentId?: CheckType;
  search?: string;
  sortBy?: SortByField;
  sortOrder?: SortOrder;
}

export interface CheckInventoryParams {
  inventoryId: string;
  checked: boolean;
  serviceTicketId?: string;
  notes?: string;
  timestamp?: Date | string;
}

export interface InventoryMetrics {
  totalInventory: {
    packages: number;
    pieces: number;
    parts: number;
  };
  totalValue: number;
  totalStorageSpace: number;
  monthlyRevenue: number;
  totalVolumeBK: number;
  totalVolumeLI: number;
}

export interface InventoryHistoryEntry {
  id: string;
  inventoryId: string;
  status: InventoryStatusCode;
  checked: boolean;
  timestamp: Date;
  locationId?: string;
  serviceTicketId?: string;
  serviceTicket?: TServiceTicket;
  notes?: string;
  createdBy?: string;
  createdAt: Date;
}

export interface InventoryCheckResult {
  success: boolean;
  inventory: {
    id: string;
    checked: boolean;
    status: InventoryStatusCode;
  };
  history: InventoryHistoryEntry;
}
